<!-- Button -->
<button mat-icon-button [matMenuTriggerFor]="userActions">
    <span class="relative inline-flex items-center justify-center">
        @if (fotoPerfil) {
            <img 
                [src]="fotoPerfil" 
                alt="Foto de perfil"
                class="rounded-full object-cover border-2 border-orange-500"
                style="width: 36px; height: 36px; min-width: 36px; min-height: 36px; max-width: 36px; max-height: 36px; display: block;" />
        } @else {
            <mat-icon [svgIcon]="'heroicons_outline:user-circle'" class="text-white"></mat-icon>
        }
    </span>
</button>

<mat-menu class="bg-zinc-900" [xPosition]="'before'" #userActions="matMenu">
    <button mat-menu-item>
        <span class="flex flex-col leading-none">
            <span class="mt-1.5 text-md font-medium">{{nomeUsuario}}</span>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider>

    <!-- Meu Perfil -->
    <button mat-menu-item (click)="meuPerfil()">
        <mat-icon [svgIcon]="'heroicons_outline:user'"></mat-icon>
        <span>Meu Perfil</span>
    </button>

    <!-- Minha Imobiliária: Apenas ADM_IMOBILIARIA -->
    <button mat-menu-item (click)="minhaImobiliaria()" *hasProfile="[PerfilEnum.ADM_IMOBILIARIA]">
        <mat-icon [svgIcon]="'heroicons_outline:building-office'"></mat-icon>
        <span>Minha Imobiliária</span>
    </button>

   <button mat-menu-item (click)="myCommissions()" *hasProfile="[PerfilEnum.ADM_SISTEMA, PerfilEnum.PARCEIRO]">
       <mat-icon [svgIcon]="'heroicons_outline:currency-dollar'"></mat-icon>
       <span>Comissões</span>
   </button>

    <!-- Solicitações Enterprise: Apenas ADM_SISTEMA -->
    <button mat-menu-item (click)="solicitacoesEnterpriseRedirect()" *hasProfile="[PerfilEnum.ADM_SISTEMA]">
        <mat-icon [svgIcon]="'heroicons_outline:sparkles'"></mat-icon>
        <span>Solic. Enterprise</span>
    </button>

    <!-- Parcerias Comerciais: ADM_SISTEMA e ADM_PARCERIA -->
    <button mat-menu-item (click)="parceriaComercialRedirect()" *hasProfile="[PerfilEnum.ADM_SISTEMA, PerfilEnum.ADM_PARCERIA]">
        <mat-icon [svgIcon]="'heroicons_outline:briefcase'"></mat-icon>
        <span>Parcerias Comerciais</span>
    </button>

    <!-- Cadastros (submenu) — agrupamento exclusivo do ADM_SISTEMA (acessa tudo) -->
    <button mat-menu-item [matMenuTriggerFor]="cadastrosMenu"
            *hasProfile="[PerfilEnum.ADM_SISTEMA]">
        <mat-icon [svgIcon]="'heroicons_outline:folder-plus'"></mat-icon>
        <span>Cadastros</span>
    </button>

    <!-- Usuários — direto no menu raiz para ADM_IMOBILIARIA e PARCEIRO (não agrupado) -->
    <button mat-menu-item (click)="userRedirect()"
            *hasProfile="[PerfilEnum.ADM_IMOBILIARIA, PerfilEnum.PARCEIRO]">
        <mat-icon [svgIcon]="'heroicons_outline:users'"></mat-icon>
        <span>Usuários</span>
    </button>

    <!-- Parâmetros do Sistema: Apenas ADM_SISTEMA -->
    <button mat-menu-item (click)="parametrosRedirect()" *hasProfile="[PerfilEnum.ADM_SISTEMA]">
        <mat-icon [svgIcon]="'heroicons_outline:cog-6-tooth'"></mat-icon>
        <span>Parâmetros</span>
    </button>

    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="signOut()">
        <mat-icon
            [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"
        ></mat-icon>
        <span>Sair</span>
    </button>
</mat-menu>

<!-- Submenu: Cadastros -->
<mat-menu class="bg-zinc-900" #cadastrosMenu="matMenu">
    <button mat-menu-item (click)="userRedirect()" *hasProfile="[PerfilEnum.ADM_SISTEMA, PerfilEnum.ADM_IMOBILIARIA, PerfilEnum.PARCEIRO]">
        <mat-icon [svgIcon]="'heroicons_outline:users'"></mat-icon>
        <span>Usuários</span>
    </button>
    <button mat-menu-item (click)="imobRedirect()" *hasProfile="[PerfilEnum.ADM_SISTEMA]">
        <mat-icon [svgIcon]="'heroicons_outline:building-office-2'"></mat-icon>
        <span>Imobiliárias</span>
    </button>
    <button mat-menu-item (click)="cupomRedirect()" *hasProfile="[PerfilEnum.ADM_SISTEMA]">
        <mat-icon [svgIcon]="'heroicons_outline:ticket'"></mat-icon>
        <span>Cupons</span>
    </button>
    <button mat-menu-item (click)="trilhaRedirect()" *hasProfile="[PerfilEnum.ADM_SISTEMA]">
        <mat-icon [svgIcon]="'heroicons_outline:map-pin'"></mat-icon>
        <span>Trilhas</span>
    </button>
    <button mat-menu-item (click)="moduloRedirect()" *hasProfile="[PerfilEnum.ADM_SISTEMA]">
        <mat-icon [svgIcon]="'heroicons_outline:rectangle-stack'"></mat-icon>
        <span>Módulos</span>
    </button>
    <button mat-menu-item (click)="aulaRedirect()" *hasProfile="[PerfilEnum.ADM_SISTEMA]">
        <mat-icon [svgIcon]="'heroicons_outline:film'"></mat-icon>
        <span>Aulas</span>
    </button>
    <button mat-menu-item (click)="bannerRedirect()" *hasProfile="[PerfilEnum.ADM_SISTEMA]">
        <mat-icon [svgIcon]="'heroicons_outline:photo'"></mat-icon>
        <span>Banner</span>
    </button>
</mat-menu>

